import { ReactNode } from 'react';

import { SUPPORTED_CHAIN_IDS } from 'shared/config/config.types';

import LogoBinance from 'assets/exchanges/binance.svg?react';
import LogoKraken from 'assets/exchanges/kraken.svg?react';
import LogoKucoin from 'assets/exchanges/kucoin.svg?react';

type Exchange = {
  id: string;
  logo: ReactNode;
  url: string;
};

enum ChainNames {
  ETHEREUM = 'ETH',
  POLYGON = 'POL',
}

const DEFAULT_TOKENS: Record<number, string> = {
  [SUPPORTED_CHAIN_IDS.ETHEREUM]: ChainNames.ETHEREUM,
  [SUPPORTED_CHAIN_IDS.ARBITRUM]: ChainNames.ETHEREUM,
  [SUPPORTED_CHAIN_IDS.POLYGON]: ChainNames.POLYGON,
  [SUPPORTED_CHAIN_IDS.BASE]: ChainNames.ETHEREUM,
};

export const EXCHANGES = (chainId: number): Exchange[] => {
  const symbol = DEFAULT_TOKENS[chainId] ?? ChainNames.ETHEREUM;

  return [
    {
      id: 'kraken',
      logo: <LogoKraken aria-label="Kraken" />,
      url: `https://www.kraken.com/learn/buy-crypto`,
    },
    {
      id: 'binance',
      logo: <LogoBinance aria-label="Binance" />,
      url: `https://www.binance.com/en/crypto/buy/USD/${symbol}`,
    },
    {
      id: 'kucoin',
      logo: <LogoKucoin aria-label="Kucoin" />,
      url: `https://www.kucoin.com/express`,
    },
  ];
};
